import Vue from "vue";

export default {
  async get(take, skip) {
    return (await Vue.http.post("/api/push/list", { take, skip })).data;
  },
  async setAllRead() {
    return (await Vue.http.post("/api/push/allread")).data;
  },
  async setRead(messageIds) {
    return (await Vue.http.post("/api/push/read", { messageIds })).data;
  }
}



// WEBPACK FOOTER //
// ./_common/services/push.service.js